export default "__VITE_ASSET__8bdf5b9f__"